module.exports = __webpack_public_path__ + "static/media/fastWindow2.f3feb315.jpg";